import { InterventionTypeColorEnum, InterventionTypeEnum } from 'api/carVerification/enums/InterventionTypeEnum';
import colors from 'styles/export/colors.module.scss';

export const getInterventionTypeStatusColor = (type: InterventionTypeEnum) => {
	return { textColor: colors.white, color: InterventionTypeColorEnum[type] };
};
